import type { TMessages } from '@/types/TMessages'

export const messages = { masculine: 'Все', feminine: 'Вся' } satisfies TMessages
